import React from 'react'

import Link from '@mui/material/Link'

interface LinkWrapperProps {
  linkUrl?: string
  childElement: React.ReactNode
}

const ConditionalLinkWrapper = ({ linkUrl, childElement }: LinkWrapperProps) =>
  linkUrl ? (
    <Link href={linkUrl} underline="none">
      {childElement}
    </Link>
  ) : (
    // eslint-disable-next-line
    <>{childElement}</>
  )

export default ConditionalLinkWrapper
